import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import BottomSheet from "@/components/BottomSheet";
import { formatNominalInput, parseNominal, todayYMD } from "@/lib/format";

export default function BayarHutangForm({
  open,
  onClose,
  onSaved,
  hutangList = [],
  rekeningList = [],
}) {
  const aktif = hutangList.filter((h) => h.status === "aktif");
  const [hutangId, setHutangId] = useState(aktif[0]?.id || "");
  const [tanggal, setTanggal] = useState(todayYMD());
  const [nominal, setNominal] = useState("");
  const [rekeningId, setRekeningId] = useState(rekeningList[0]?.id || "");
  const [busy, setBusy] = useState(false);
  const [keterangan, setKeterangan] = useState("");

  useEffect(() => {
    if (open) {
      setHutangId(aktif[0]?.id || "");
      setTanggal(todayYMD());
      setNominal("");
      setRekeningId(rekeningList[0]?.id || "");
      setKeterangan("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const selected = aktif.find((h) => h.id === hutangId);

  const submit = async (e) => {
    e.preventDefault();
    const n = parseNominal(nominal);
    if (!hutangId) return toast.error("Pilih hutang");
    if (!rekeningId) return toast.error("Pilih rekening");
    if (n <= 0) return toast.error("Jumlah bayar harus > 0");
    if (selected && n > selected.sisa)
      return toast.error("Jumlah bayar melebihi sisa hutang");

    setBusy(true);
    try {
      await api.post(`/hutang/${hutangId}/bayar`, {
        tanggal,
        nominal: n,
        rekening_id: rekeningId,
        keterangan: keterangan.trim() || null,
      });
      toast.success("Pembayaran hutang tercatat");
      onClose();
      onSaved && onSaved();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <BottomSheet
      open={open}
      onClose={onClose}
      title="Bayar Hutang"
      testId="bayar-hutang-sheet"
    >
      <form onSubmit={submit} className="space-y-4" data-testid="bayar-hutang-form">
        <Field label="Pilih hutang aktif">
          <select
            value={hutangId}
            onChange={(e) => setHutangId(e.target.value)}
            data-testid="bayar-hutang-select"
            className={inputCls}
            required
          >
            <option value="">— Pilih hutang —</option>
            {aktif.map((h) => (
              <option key={h.id} value={h.id}>
                {h.deskripsi} — sisa Rp {h.sisa.toLocaleString("id-ID")}
              </option>
            ))}
          </select>
        </Field>
        <Field label="Tanggal bayar">
          <input
            type="date"
            value={tanggal}
            onChange={(e) => setTanggal(e.target.value)}
            data-testid="bayar-hutang-tanggal"
            className={inputCls}
            required
          />
        </Field>
        <Field label="Jumlah bayar (Rp)">
          <input
            type="text"
            inputMode="numeric"
            value={nominal}
            onChange={(e) => setNominal(formatNominalInput(e.target.value))}
            data-testid="bayar-hutang-nominal"
            className={inputCls}
            required
          />
        </Field>
        <Field label="Dari rekening">
          <select
            value={rekeningId}
            onChange={(e) => setRekeningId(e.target.value)}
            data-testid="bayar-hutang-rekening"
            className={inputCls}
            required
          >
            <option value="">— Pilih rekening —</option>
            {rekeningList.map((r) => (
              <option key={r.id} value={r.id}>
                {r.nama} ({r.bank})
              </option>
            ))}
          </select>
        </Field>
        <Field label="Keterangan (opsional)">
  <input
    type="text"
    value={keterangan}
    onChange={(e) => setKeterangan(e.target.value)}
    placeholder="Contoh: Kredivo Juli, Spinjam Agustus..."
    className={inputCls}
  />
</Field>

        {aktif.length === 0 && (
          <div className="text-xs text-slate-500 bg-slate-50 border border-slate-100 rounded-lg p-3">
            Tidak ada hutang aktif untuk dibayar.
          </div>
        )}

        <button
          type="submit"
          disabled={busy || aktif.length === 0}
          data-testid="bayar-hutang-submit"
          className="w-full h-11 rounded-xl font-semibold text-sm text-white tap disabled:opacity-60"
          style={{ backgroundColor: "#1F4E5F" }}
        >
          {busy ? "Menyimpan..." : "Bayar"}
        </button>
      </form>
    </BottomSheet>
  );
}

const inputCls =
  "mt-1 w-full h-11 px-3 rounded-xl border border-slate-200 focus:border-[#1F4E5F] focus:outline-none text-sm bg-white";

function Field({ label, children }) {
  return (
    <label className="block">
      <span className="text-xs font-semibold text-slate-600">{label}</span>
      {children}
    </label>
  );
}
